module.exports = __webpack_public_path__ + "img/14-03_Acting Fairly.04c899c1.svg";